import {useState, useEffect, useRef} from 'react';
import { UNSAFE_WithComponentProps, useNavigate } from 'react-router';
import "./Stylesheets/Login.css";
import axios from 'axios';
import { s } from 'react-router/dist/development/index-react-server-client-kY8DvDF3';

export default function AdminLogin() {

    const [isRegistering, setRegister] = useState(false);

    const navigate = useNavigate();

    const [error, setError] = useState("");

    const [message, setMessage] = useState("");

    const backend_url = process.env.REACT_APP_BACKEND_URL;

    // Verify Session
    useEffect(() => {

        axios.get(`${backend_url}/Login/ProcessSession/`, {withCredentials: true})
        .then(res => {
            if (res.data.validSession){
                navigate('/admin');
            }
        })
        .catch(err => {});
    }, [])

    const handleLogin = (e : React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        // Process Login
        const formData = new FormData(e.currentTarget);
        const username = formData.get("Username");
        const password = formData.get("Password");

        const body = {
            Username: username,
            Password: password
        }

        axios.post(`${backend_url}/Login/Login`, body, {withCredentials: true})
        .then(res => {
            if (res.status == 200 && res.data.loginSuccess){
                navigate('/admin');
            }
        })
        .catch( err => {
            console.log(err.response.data);
            setError(err.response.data.message);
        })
    }

    const handleRegister = (e : React.FormEvent<HTMLFormElement>) => {

        e.preventDefault();
        // Process Registration

        const formData = new FormData(e.currentTarget);
        const username = formData.get("Username");
        const password = formData.get("Password");
        const cpassword = formData.get("CPassword");

        if (password !== cpassword){
            alert("Passwords do not match.");
            return;
        }
        const body = {
            Username: username,
            Password: password
        }

        // Note: the point of withCredentials is to allow cookies to be set cross-origin.
        axios.post(`${backend_url}/Login/Register`, body, {withCredentials: true })
        .then( res => {
            if (res.status == 200 ){
                setMessage(res.data.message);
            }else if (res.status == 400){
                setError(res.data.message);
            }
        })
        .catch( err => {
            console.log(err.response.data);
            setError(err.response.data.message);
        })
    }


    const renderLogin = () => {
        return(
            <>
             <h1>Admin Login</h1>
            <form   className={"login-form"}onSubmit={handleLogin}>
                    <input name={"Username"} placeholder='Username'></input>
                    <input type={"password"} placeholder='Password' name={"Password"}></input>
                    {error ? <p className='error-text'>{error}</p> : null}
                    <button type={"submit"}>Submit</button>
            </form>
            <hr></hr>
            <h3>Dont have an account?</h3>
            <a onClick={() => setRegister(true)}>Create an account</a>
            </>
        )
    }

    const renderRegister = () => {
        return(
            <>
            <h1>Register</h1>
                <form className={"login-form"}onSubmit={handleRegister}>
                        <input name={"Username"} placeholder='Username' required></input>
                        <input type={"password"} placeholder='Password' name={"Password"} required minLength={9}></input>
                        <input type={"password"} placeholder='Confirm Password' name={"CPassword"} required ></input>
                        {error ? <p className='error-text'>{error}</p> : null}
                        <button type={"submit"}>Submit</button>
                </form>
                <span>{message}</span>
                <hr></hr>
                <h3>Already have an account?</h3>
                <a onClick={() => setRegister(false)}>Login</a>
            </>
        )
    }

    return(
        <>
         <div className={"login-div"}>
                {isRegistering ? renderRegister() : renderLogin()}
         </div>
         
        </>
        


    )
}